import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'surveyType',
})
export class SurveysTypePipe implements PipeTransform {
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public transform(type: any) {
        switch (type) {
            case 'DOCTOR_DIAGNOSTICS_MANUAL':
                return 'Ročni vnos (Doktor)';
            case 'TABLET':
                return 'Tablica';
            default:
                return type;
        }
    }
}
